import { createBrowserRouter } from 'react-router';
import RootLayout from './layout/RootLayout';
import { AuthLayout } from './layout/AuthLayout';
import Dashboard from './pages/dashboard/Dashboard';
import ExploreProducts from './pages/explore-products/ExploreProducts';
import BuyerInventory from './pages/buyer-inventory/BuyerInventory';
import { ProductView } from './pages/product-view/ProductView';
import Cart from './pages/cart/Cart';
import Orders from './pages/orders/Orders';
import { OrderView } from '~/pages/order-view/OrderView';
import { Checkout } from './pages/checkout/Checkout';
import { Home } from './pages/home/Home';
import { SignInRedirect } from '~/components/auth/SignInRedirect.tsx';
import { RequireAuth } from '~/components/RequireAuth.tsx';
import { EditMyProduct } from './pages/my-products-edit/EditMyProduct';
import { MyProducts } from './pages/my-products/MyProducts';
import OrderBuilder from '~/pages/order-builder/OrderBuider.tsx';
import SignedOut from '~/components/auth/SignedOut.tsx';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <RootLayout />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: 'signin',
        element: <SignInRedirect />,
      },
      {
        path: 'signed-out',
        element: <SignedOut />,
      },
    ],
  },

  // Authenticated routes

  {
    path: '/',
    element: (
      <RequireAuth>
        <AuthLayout />
      </RequireAuth>
    ),
    children: [
      {
        path: '/dashboard',
        element: <Dashboard />,
      },
      {
        path: '/buyer-inventory',
        element: <BuyerInventory />,
      },
      {
        path: '/explore-products',
        element: <ExploreProducts />,
      },
      {
        path: '/cart',
        element: <Cart />,
      },
      {
        path: '/cart/:id/checkout/address/:addressId',
        element: <Checkout />,
      },
      {
        path: '/explore-products/:productId',
        element: <ProductView />,
      },
      {
        path: '/orders/view/:orderId',
        element: <OrderView />,
      },
      {
        path: '/orders/*',
        element: <Orders />,
      },
      {
        path: '/my-products',
        element: <MyProducts />,
      },
      // {
      //   path: '/my-products/platform-products',
      //   element: <PlatformProductList />,
      // },
      {
        path: '/my-products/:inventoryId/edit',
        element: <EditMyProduct />,
      },
      {
        path: '/order-builder/view',
        element: <OrderBuilder />,
      },
    ],
  },
]);
